module.exports = "body {\n\tmin-height: 920px;\n\tmin-width: 325px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main